import Card6Ship from "../Previews/Card6Ship/Preview";
import PalaceCardPreview from "../Previews/PalaceCardPreview/Preview1/Preview";
import PreviewPalace from "../Previews/PreviewPalace/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";

export const ThePalaceData = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipBannerPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 1,
      fields: [
        {
          title: "Page Logo",
          key: "logo",
          className: "col-lg-3",
          placeholder: "Upload Page Logo",
          type: "file",
          withAlt: true,
        },
        {
          title: "Simplified Chinese Logo",
          key: "simplified_chinese_logo",
          placeholder: "Upload Simplified Chinese Page Logo",
          className: "col-lg-3",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "Traditional Chinese Logo",
          key: "traditional_chinese_logo",
          className: "col-lg-3",
          placeholder: "Upload Traditional Chinese Page Logo",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "Bahasa Logo",
          key: "bahasa_logo",
          className: "col-lg-3",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
        },

        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

      ],
      preview: (activetab, cardData) => (
        <PreviewPalace activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

      ],
      level1: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

      ],
      preview: (activetab, cardData) => (
        <Card6Ship activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [],
      level1: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "English Brochure (Dream Cruises)",
          key: "english_file",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload English Brochure",
          filetype: "pdf",
          required: false,
        },
        {
          title: "Simplified Chinese Brochure (Dream Cruises)",
          key: "simplified_chinese_file",
          className: "col-lg-3",
          placeholder: "Upload Simplified Chinese Brochure ",
          type: "file",
          filetype: "pdf",
          required: false,
        },
        {
          title: "Traditional Chinese Brochure (Dream Cruises)",
          key: "traditional_chinese_file",
          className: "col-lg-3",
          placeholder: "Upload Traditional Chinese Brochure ",
          type: "file",
          filetype: "pdf",
          required: false,
        },
        {
          title: "Bahasa Brochure (Dream Cruises)",
          key: "bahasa_file",
          className: "col-lg-3",
          type: "file",
          filetype: "pdf",
          required: false,
        },
        {
          title: "English Brochure (Star Cruises)",
          key: "star_cruises_english_file",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload English Brochure",
          filetype: "pdf",
          required: false,
        },
        {
          title: "Simplified Chinese Brochure (Star Cruises)",
          key: "star_cruises_simplified_chinese_file",
          className: "col-lg-3",
          placeholder: "Upload Simplified Chinese Brochure ",
          type: "file",
          filetype: "pdf",
          required: false,
        },
        {
          title: "Traditional Chinese Brochure (Star Cruises)",
          key: "star_cruises_traditional_chinese_file",
          className: "col-lg-3",
          placeholder: "Upload Traditional Chinese Brochure ",
          type: "file",
          filetype: "pdf",
          required: false,
        },
        {
          title: "Bahasa Brochure (Star Cruises)",
          key: "star_cruises_bahasa_file",
          className: "col-lg-3",
          type: "file",
          filetype: "pdf",
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <PalaceCardPreview activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
